import React, { useCallback, useEffect, useRef } from 'react';
import CallControl from './call-control';
import { Box, ThemeProvider, styled } from '@mui/material';
import { callTheme } from '../material-theme';
import Draggable from 'react-draggable';
import CallWarnings from './call-warnings';
import { useDesktop } from '@revenuewell/logic-desktop';
import { useLwp } from '../../hooks/use-lwp';
import useResizeObserver from 'use-resize-observer';
import { throttle } from 'lodash';

const Overlay = styled(Box)({
  position: 'absolute',
  width: '100%',
  height: '0',
  overflow: 'visible'
});


export const CallList = () => {
  const {
    phoneState: { callStatus }
  } = useLwp();
  const { isDesktopApplication, isDesktopWidget, resizeWindow, showWindow, hideWindow } = useDesktop();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isDesktopApplication() && isDesktopWidget) {
      callStatus === 'initiating' || callStatus === 'inprogress' ? showWindow() : hideWindow();
    }
  }, [callStatus, isDesktopApplication, isDesktopWidget]);

  const updateScrollableHeightThrotled = () =>
    throttle(() => {
      if (containerRef.current) {
        resizeWindow(40, containerRef.current.scrollHeight);
        setTimeout(() => {
          if (containerRef.current) resizeWindow(40, containerRef.current.scrollHeight);
        }, 25);
      }
    }, 25);

  const updateScrollableHeight = useCallback(updateScrollableHeightThrotled(), []);
  const resizeObserver = useResizeObserver<HTMLDivElement>({ onResize: updateScrollableHeight });
  useResizeObserver<HTMLDivElement>({ onResize: updateScrollableHeight, ref: containerRef });

  const renderContent = () => (
    <div
      ref={containerRef}
      style={{
        position: 'absolute',
        right: '16px',
        top: '16px',
        zIndex: isDesktopApplication() ? 200 : 999
      }}
    >
      <div ref={resizeObserver.ref}>
        <CallWarnings />
        <CallControl />
      </div>
    </div>
  );

  const render = () => {
    if (!isDesktopApplication()) return <Draggable>{renderContent()}</Draggable>;
    return renderContent();
  };

  return (
    <Overlay>
      <ThemeProvider theme={callTheme}>{render()}</ThemeProvider>
    </Overlay>
  );
};
